import { Link } from 'react-router-dom';

export default function DashboardPage() {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-white">Dashboard</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Instances Card */}
        <Link
          to="/instances"
          className="bg-gray-800 rounded-lg p-6 hover:bg-gray-750 transition border border-gray-700 hover:border-blue-500"
        >
          <h3 className="text-lg font-semibold text-white mb-2">Instances</h3>
          <p className="text-gray-400 text-sm mb-4">
            View and manage all user instances
          </p>
          <span className="text-blue-500 text-sm">Manage &rarr;</span>
        </Link>

        {/* Orphans Card */}
        <Link
          to="/orphans"
          className="bg-gray-800 rounded-lg p-6 hover:bg-gray-750 transition border border-gray-700 hover:border-yellow-500"
        >
          <h3 className="text-lg font-semibold text-white mb-2">
            Orphan Resources
          </h3>
          <p className="text-gray-400 text-sm mb-4">
            Detect and cleanup orphan Machines and Volumes
          </p>
          <span className="text-yellow-500 text-sm">Check &rarr;</span>
        </Link>

        {/* Quick Actions Card */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <h3 className="text-lg font-semibold text-white mb-2">
            Quick Actions
          </h3>
          <div className="space-y-2">
            <a
              href="https://fly.io/apps/openclaw-machines"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-gray-400 hover:text-white text-sm"
            >
              Fly.io Dashboard &rarr;
            </a>
            <a
              href="https://dash.cloudflare.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-gray-400 hover:text-white text-sm"
            >
              Cloudflare Dashboard &rarr;
            </a>
          </div>
        </div>
      </div>

      {/* Info Section */}
      <div className="bg-gray-800/50 rounded-lg p-6 border border-gray-700">
        <h3 className="text-lg font-semibold text-white mb-4">API Status</h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-400">Instance List API</span>
            <span className="text-yellow-500">Placeholder</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Delete Instance API</span>
            <span className="text-green-500">Ready</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Orphan Detection API</span>
            <span className="text-yellow-500">Placeholder</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Cleanup API</span>
            <span className="text-yellow-500">Placeholder</span>
          </div>
        </div>
        <p className="text-gray-500 text-xs mt-4">
          Yellow items are placeholders and will be implemented in Phase 4-5.
        </p>
      </div>
    </div>
  );
}
